import { clsx } from 'clsx'
import { CSSProperties, FunctionComponent, MouseEvent, SVGProps } from 'react'
import { omit } from 'util/object'
import css from './Icon.module.scss'
import error from './svg/error.svg'
import shopping_bag from './svg/shopping_bag.svg'
import west from './svg/west.svg'

type SvgProps = SVGProps<SVGSVGElement> & { title?: string }
type SvgComponent = FunctionComponent<SvgProps>

export type IconName =
  | 'error'
  | 'shopping_bag'
  | 'west'

function getSvg(name: IconName): SvgComponent | undefined {
  switch (name) {
    case 'error':
      return error
    case 'shopping_bag':
      return shopping_bag
    case 'west':
      return west
    default:
      console.error('unknown icon', name)
      return undefined
  }
}

type Props = {
  name: IconName
  size?: number
  title?: string
  primary?: boolean
  secondary?: boolean
  tertiary?: boolean
  error?: boolean
  className?: string
  style?: CSSProperties
  onClick?(event: MouseEvent): void
  onMouseDown?(event: MouseEvent): void
}

/**
 * Preview with search - https://fonts.google.com/icons
 */
export function Icon(props: Props) {
  const { name, size, title, primary, secondary, tertiary, error, onClick, onMouseDown } = props

  const color = error ? css.error : primary ? css.primary :
    secondary ? css.secondary : tertiary ? css.tertiary : undefined
  const className = clsx(props.className, css.icon, color)
  const style = omit<CSSProperties>({ ...props.style })

  const Svg = getSvg(name)
  if (!Svg) return null

  return <Svg className={className} style={style} width={size} height={size}
    title={title} onClick={onClick} onMouseDown={onMouseDown}>
    {name}
  </Svg>
}
